// Add your custom JS here.

// core version + navigation, pagination modules:
import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", function () {
    const swiperwts = new Swiper(".whattheysay-swiper-container", {
        // Optional parameters
        // effect: "coverflow",
        // grabCursor: true,
        // centeredSlides: true, 
        slidesPerView: 4,
        spaceBetween: 10,
        pagination: {
            el: '.whattheysay-swiper-pagination',
            dynamicBullets: true,
            clickable: true, // Kulaté bullety budou klikatelné
        },
        // loop: true,
        speed: 600,
        /*
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true,
                },
        */
        a11y: {
            prevSlideMessage: "Předchozí",
            nextSlideMessage: "Další",
        },


        // Navigation arrows
        navigation: {
            nextEl: ".whattheysay-swiper-button-next",
            prevEl: ".whattheysay-swiper-button-prev",
        },

        breakpointsInverse: true,
        breakpoints: {
            20: {
                slidesPerGroup: 1,   // Kolik snímků bude přeskočeno najednou
                slidesPerView: 1.15,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
                slidesPerGroup: 1,   // Kolik snímků bude přeskočeno najednou
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 30,
                slidesPerGroup: 1,   // Kolik snímků bude přeskočeno najednou
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 30,
                slidesPerGroup: 1,   // Kolik snímků bude přeskočeno najednou
            },
            1440: {
                slidesPerView: 4,
                spaceBetween: 92,
                slidesPerGroup: 1,   // Kolik snímků bude přeskočeno najednou
            },
        },


    });
});
